import { useNavigate, useSearchParams } from "react-router-dom";
import {
  IColaboradorAtualizarForm,
  IColaboradorFormRHF,
} from "../../../types/colaborador";
import { useContextSite } from "../../../context/Context";
import { Colaborador } from "../../../services/Colaborador";
import { toast } from "react-toastify";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

export const useCollaboratorDetail = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();
  const { isAdmin, canResetPassword } = useUserPermissions();

  const shouldShowResetPasswordButton = isAdmin() || canResetPassword();

  function handleSubmit(data: IColaboradorFormRHF) {
    setIsLoad(true);

    const PAYLOAD: IColaboradorAtualizarForm = {
      nome: data?.nome,
      perfis: data?.perfis?.map((e) => e.value),
      telefone: data?.telefone,
      tipo: data?.tipo,
      uuid: id,
      email: data?.email,
      uuidDelivery: data?.uuidDelivery,
      uuidLoja: data?.uuidLoja,
      ativo: data?.ativo,
    };

    Colaborador.atualizar(PAYLOAD)
      .then(() => {
        toast.success("Colaborador atualizado com sucesso");
        setTimeout(() => {
          navigate("/configuracoes/colaboradores");
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          toast.error(message);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function handleResetPassword() {
    setIsLoad(true);
    Colaborador.resetPassword({ uuid: id! })
      .then(() => {
        toast.success("Senha redefinida com sucesso");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { handleSubmit, shouldShowResetPasswordButton, handleResetPassword };
};
